var config = module.exports;
config.DEBUG = false;
config.serverUrl="https://abc3d.yubin.tw/api";
